<script>
  import { createEventDispatcher, onDestroy } from "svelte";
  import { createForm } from "svelte-forms-lib";
  import * as yup from "yup";
  import Datepicker from "svelte-calendar";

  import Snackbar, { Label, Actions } from "@smui/snackbar/bare.js";
  import "@smui/snackbar/bare.css";

  import { sendForm } from "../api";

  const dispatch = createEventDispatcher();

  // let dateFormat = "#{l}, #{F} #{j}, #{Y}";
  // let dateChosen;
  // let date;
  // let dateFormatted
  let submitSnackbar;
  let sb = {
    // label: 'Error',
    // class: 'warning'
  };

  let defaults = {
    angler: {
      firstname: "",
      lastname: "",
      age: "",
      fitness: "",
      medical: "",
      dietery: "",
      // fishing: "",
      experience: "",
      licence: "",
      rodreel: "",
      waders: "",
      wadersize: ""
    },
    date: {
      start: new Date(),
      end: new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 365 * 3), // 3 yrs
      format: "#{l}, #{F} #{j}, #{Y}",
      chosen: false
    },
    trips: [ "Driftboat Fishing", "Fly Fishing", "Backcountry Fishing"],
    people: [1, 2],
    fishing: ["Fly Fishing", "Spin Fishing"],
    experience: ["Beginner", "Novice", "Intermediate", "Advanced", "Expert"],
    licence: ["Day licence", "Full season", "Full season with backcountry"],
    yesno: ["Yes", "No"],
    size: ["S", "M", "L", "XL", "2XL"]
  };

  // $: form.date = defaults.date.chosen ? date : '';

  // based on https://svelte-forms-lib-sapper-docs.tjin.now.sh/yup

  const makeRequest = () => new Promise(resolve => setTimeout(resolve, 1000));

  const {
    form,
    errors,
    state,
    isValid,
    isValidating,
    isSubmitting,
    handleChange,
    handleSubmit
  } = createForm({
    initialValues: {
      firstname: "",
      lastname: "",
      email: "",
      phone: "",
      date: "",
      trip: "",
      accommodation: "",
      people: "",
      anglers: [defaults.angler],
      comments: "",
      terms: "",
      safety: "",
      waiver: "",
      photorelease: ""
    },
    validationSchema: yup.object().shape({
      firstname: yup.string().required(),
      lastname: yup.string().required(),
      email: yup
        .string()
        .email()
        .required(),
      phone: yup.string().required(),
      date: yup.date().required(),
      trip: yup
        .string()
        .required()
        .oneOf(defaults.trips),
      accommodation: yup.string(),
      people: yup
        .number()
        .required()
        .oneOf(defaults.people),
      anglers: yup.array().of(
        yup.object().shape({
          firstname: yup.string().required(),
          lastname: yup.string().required(),
          age: yup.string(),
          fitness: yup.string(),
          medical: yup.string(),
          dietery: yup.string(),
          // fishing: yup
          //   .string()
          //   .required()
          //   .oneOf(defaults.fishing),
          experience: yup
            .string()
            .required()
            .oneOf(defaults.experience),
          licence: yup
            .string()
            .required()
            .oneOf(defaults.licence),
          rodreel: yup
            .string()
            .required()
            .oneOf(defaults.yesno),
          waders: yup
            .string()
            .required()
            .oneOf(defaults.yesno),
          wadersize: yup
            .string()
            // .required()
            // .oneOf(defaults.size)
        })
      ),
      comments: yup.string(),
      terms: yup
        .boolean()
        .required()
        .oneOf([true]),
      safety: yup
        .boolean()
        .required()
        .oneOf([true]),
      waiver: yup
        .boolean()
        .required()
        .oneOf([true]),
      photorelease: yup
        .boolean()
        .required()
        .oneOf([true])
    }),
    onSubmit: values => {
      console.log("valid", values);

      // sb.label = "Success! Your booking has been submitted.";
      // sb.class = "success";
      // submitSnackbar.open(/* { labelText: 'Success', className: 'success', timeoutMs: 0 }*/);

      // alert(JSON.stringify(values));
      // return makeRequest().then( res => {
      //   console.log('res', res);
      //   sb.label = 'Success! Your booking has been submitted.';
      //   sb.class = 'success';
      //   submitSnackbar.open();
      // })

      return sendForm(values)
        .then(res => {
          console.log("res", res);
          sb.label = "Success! Your booking has been submitted.";
          sb.class = "success";
          submitSnackbar.open(/* { labelText: 'Success', className: 'success', timeoutMs: 0 } */);
        })
        .catch(err => {
          console.log("err", err);
          sb.label = "Error! " + err;
          sb.class = "error";
          submitSnackbar.open();
        });
    }
  });

  const sub1 = errors.subscribe(err => {
    console.log("err", err);
    if (err.email) {
      sb.label = "Error! Please fill in all required fields";
      sb.class = "error";
      submitSnackbar.open();
    }
  });
  onDestroy(sub1);

  // if (isValidating){
  //   console.log('isValidating', isValidating);
  //   console.log('isValid', isValid);
  //   if (!isValid) {
  //     console.log('isValid', isValid);
  //   }
  // }
  // if (isValidating && !isValid) {
  //   console.log('isValid', isValid);
  //   sb.label = 'Error! Please fill in all required fields';
  //   sb.class = 'error';
  //   submitSnackbar.open();
  // }

  const add = () => {
    $form.anglers = $form.anglers.concat(defaults.angler);
    $errors.anglers = $errors.anglers.concat(defaults.angler);
  };

  const remove = i => {
    $form.anglers = $form.anglers.filter((u, j) => j !== i);
    $errors.anglers = $errors.anglers.filter((u, j) => j !== i);
    console.log("removed len", $form.anglers.length);
  };

  const peopleToAnglers = () => {
    // let people = await $form.people;
    // console.log(people);
    setTimeout(() => {
      // console.log('len', $form.anglers.length, 'ppl', $form.people);
      if ($form.anglers.length < $form.people) {
        add();
      } else if ($form.anglers.length !== 1) {
        remove(1);
      }
    }, 100);
  };

  const copyMainContact = () => {
    if ($form.firstname) {
      $form.anglers[0].firstname = $form.firstname;
    }
    if ($form.lastname) {
      $form.anglers[0].lastname = $form.lastname;
    }
  };

  const dialogHandler = type => {
    dispatch("dialog", { type });
  };

  const dateHandler = () => {
    console.log("dateHandler");
    return defaults.date.chosen ? $form.date : "";
  };
</script>

<style>
  .bookings {
    text-align: left;
    padding-bottom: 80px;
  }
  .grid {
    grid-template-columns: 1fr;
    align-items: start;
    padding: 0 0 8px;
  }
  @media screen and (min-width: 600px) and (max-width: 959px) {
    .grid {
      grid-template-columns: 1fr 3fr;
      column-gap: 10px;
      padding: 0 0 12px;
    }
  }
  @media screen and (min-width: 960px) {
    .grid {
      grid-template-columns: 1fr 2fr;
      column-gap: 20px;
      padding: 0 0 16px;
    }
  }
  .grid .subgrid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 10px;
  }

  .smlink {
    font-size: 0.85rem;
    padding-bottom: 4px;
  }
  .smlink a {
    color: #aaa;
  }
  input.error,
  select.error {
    border-color: #a44;
  }
  input.error::placeholder {
    color: #a44;
  }
  div.error,
  span.error,
  span.error a {
    color: #b33;
  }
  div.error.pad-top {
    padding-top: 6px;
  }

  .form-field {
    margin-bottom: 0.4em;
  }
  .form-field label {
    display: none;
  }
  .full-width {
    width: 100%;
  }
  .half-width {
    width: 49%;
    /* width: calc(49% - 1px); */
  }
  @media (max-width: 959px) and (min-width: 600px) {
    .half-width {
      width: 49.2%;
    }
  }
  @media (min-width: 960px) {
    .half-width {
      width: 49.5%;
    }
  }
  .button-as-input {
    text-align: left;
    background-color: transparent;
    padding: 0.4em !important;
    border-color: #ccc !important;
    width: 100%;
    color: #7d7d7d !important;
    display: block;
  }
  .button-as-input.error {
    border-color: #a44 !important;
    color: #a44 !important;
  }
  p.angler {
    margin-bottom: 6px;
  }
  .add img,
  .remove img {
    height: 18px;
    width: 18px;
    opacity: 0.5;
  }
  .add img:hover,
  .remove img:hover {
    opacity: 1;
  }
  .close-icon img {
    width: 16px;
    height: 16px;
  }
  .loading {
    width: 16px;
    height: 16px;
  }
</style>

<div class="bookings" data-section="bookings">
  <h1>Bookings</h1>
  <p>Please fill out your details and Roger will be in touch</p>
  <form on:submit={handleSubmit} data-form="booking">
    <div class="grid">
      <div>
        <p>Main Contact</p>
      </div>
      <div>
        <div class="subgrid">
          <div class="form-field">
            <label for="firstname">firstname</label>
            <input
              type="text"
              name="firstname"
              placeholder="Firstname*"
              on:change={handleChange}
              on:blur={handleChange}
              bind:value={$form.firstname}
              class:error={$errors.firstname}
              class="full-width"
              data-input="firstname" />
          </div>
          <div class="form-field">
            <label for="lastname">lastname</label>
            <input
              type="text"
              name="lastname"
              placeholder="Lastname*"
              on:change={handleChange}
              on:blur={handleChange}
              bind:value={$form.lastname}
              class:error={$errors.lastname}
              class="full-width"
              data-input="lastname" />
          </div>
        </div>
        <div class="form-field">
          <label for="email">email</label>
          <input
            type="text"
            name="email"
            placeholder="Email*"
            on:change={handleChange}
            on:blur={handleChange}
            bind:value={$form.email}
            class:error={$errors.email}
            class="full-width"
            data-input="email" />
        </div>
        <div class="form-field">
          <label for="phone">phone</label>
          <input
            type="text"
            name="phone"
            placeholder="Phone*"
            on:change={handleChange}
            on:blur={handleChange}
            bind:value={$form.phone}
            class:error={$errors.phone}
            class="full-width"
            data-input="phone" />
        </div>
      </div>
    </div>
    <div class="grid">
      <div>
        <p>Trip Details</p>
      </div>
      <div>
        <div class="form-field">
          <Datepicker
            style="width: 100%;"
            format={defaults.date.format}
            bind:start={defaults.date.start}
            bind:end={defaults.date.end}
            bind:dateChosen={defaults.date.chosen}
            bind:formattedSelected={$form.date}
            on:change={handleChange}>
            <!-- bind:dateChosen 
          bind:selected={date}  -->
            <input
              type="text"
              name="date"
              placeholder="Date*"
              on:change={handleChange}
              on:blur={handleChange}
              bind:value={$form.date}
              class:error={$errors.date}
              class="full-width"
              data-input="date" />
            <!-- <button 
            type="button"
            class='button-as-input'  
            class:error={$errors.date} 
          >
            {#if dateChosen} {dateFormatted} {:else} Preferred Date* {/if}
          </button> -->
          </Datepicker>
        </div>
        <div class="form-field">
          <select
            name="trip"
            placeholder="Trip type*"
            on:change={handleChange}
            bind:value={$form.trip}
            class:error={$errors.trip}
            class="full-width"
            data-input="trip">
            <option value="" disabled selected>Trip type*</option>
            {#each defaults.trips as opt}
              <option value={opt}>{opt}</option>
            {/each}
          </select>
        </div>
        <div class="form-field">
          <input
            type="text"
            name="accommodation"
            placeholder="Accommodation"
            on:change={handleChange}
            on:blur={handleChange}
            bind:value={$form.accommodation}
            class="full-width"
            data-input="accommodation" />
        </div>
        <div class="form-field">
          <select
            name="people"
            placeholder="Anglers*"
            on:change={handleChange && peopleToAnglers}
            bind:value={$form.people}
            class:error={$errors.people}
            class="half-width"
            data-input="people">
            <option value="" disabled selected>Anglers*</option>
            {#each defaults.people as opt}
              <option value={opt}>{opt}</option>
            {/each}
          </select>
        </div>
      </div>
    </div>

    {#each $form.anglers as angler, i}
      <div class="grid form-group">
        <div>
          <p class="angler">Angler #{i + 1}</p>
          {#if i === 0}
            <div class="smlink">
              <a class="pointer" on:click={copyMainContact}>
                Same as Main Contact
              </a>
            </div>
          {/if}
          <!-- {#if i === 0 && $form.anglers.length < 2}
        <a class="pointer add" on:click={add}>
          <img src="./io/icons8-plus.png" alt="add" />
        </a>
      {/if}
      {#if $form.anglers.length !== 1}
        <a class="pointer remove" on:click={() => remove(i)}>
          <img src="./io/icons8-minus.png" alt="remove" />
        </a>
      {/if} -->
        </div>
        <div>
          <div class="subgrid">
            <div class="form-field">
              <input
                type="text"
                name={`anglers[${i}].firstname`}
                placeholder="Firstname*"
                on:change={handleChange}
                on:blur={handleChange}
                bind:value={$form.anglers[i].firstname}
                class="full-width"
                class:error={$errors.anglers[i].firstname}
                data-input={`anglers-${i}-firstname`} />
            </div>
            <div class="form-field">
              <input
                type="text"
                name={`anglers[${i}].lastname`}
                placeholder="Lastname*"
                on:change={handleChange}
                on:blur={handleChange}
                bind:value={$form.anglers[i].lastname}
                class="full-width"
                class:error={$errors.anglers[i].lastname}
                data-input={`anglers-${i}-lastname`} />
            </div>
          </div>
          <div class="form-field">
            <input
              type="text"
              name={`anglers[${i}].age`}
              placeholder="Age"
              on:change={handleChange}
              on:blur={handleChange}
              bind:value={$form.anglers[i].age}
              class="half-width"
              class:error={$errors.anglers[i].age}
              data-input={`anglers-${i}-age`} />
          </div>
          <div class="form-field">
            <input
              type="text"
              name={`anglers[${i}].fitness`}
              placeholder="Fitness level"
              on:change={handleChange}
              on:blur={handleChange}
              bind:value={$form.anglers[i].fitness}
              class="full-width"
              data-input={`anglers-${i}-fitness`} />
          </div>
          <div class="form-field">
            <input
              type="text"
              name={`anglers[${i}].medical`}
              placeholder="Medical conditions"
              on:change={handleChange}
              on:blur={handleChange}
              bind:value={$form.anglers[i].medical}
              class="full-width"
              data-input={`anglers-${i}-medical`} />
          </div>
          <div class="form-field">
            <input
              type="text"
              name={`anglers[${i}].dietery`}
              placeholder="Dietery requirements"
              on:change={handleChange}
              on:blur={handleChange}
              bind:value={$form.anglers[i].dietery}
              class="full-width"
              data-input={`anglers-${i}-dietery`} />
          </div>
          <!-- <div class="form-field">
            <select
              name={`anglers[${i}].fishing`}
              placeholder="Fishing type*"
              on:change={handleChange}
              bind:value={$form.anglers[i].fishing}
              class:error={$errors.anglers[i].fishing}
              class="full-width"
              data-input={`anglers-${i}-fishing`}>
              <option value="" disabled selected>Fishing type*</option>
              {#each defaults.fishing as opt}
                <option value={opt}>{opt}</option>
              {/each}
            </select>
          </div> -->
          <div class="form-field">
            <select
              name={`anglers[${i}].experience`}
              placeholder="Fishing experience*"
              on:change={handleChange}
              bind:value={$form.anglers[i].experience}
              class:error={$errors.anglers[i].experience}
              class="full-width"
              data-input={`anglers-${i}-experience`}>
              <option value="" disabled selected>Fishing experience*</option>
              {#each defaults.experience as opt}
                <option value={opt}>{opt}</option>
              {/each}
            </select>
          </div>
          <div class="form-field">
            <select
              name={`anglers[${i}].licence`}
              placeholder="Fishing licence*"
              on:change={handleChange}
              bind:value={$form.anglers[i].licence}
              class:error={$errors.anglers[i].licence}
              class="full-width"
              data-input={`anglers-${i}-licence`}>
              <option value="" disabled selected>Fishing licence*</option>
              {#each defaults.licence as opt}
                <option value={opt}>{opt}</option>
              {/each}
            </select>
          </div>
          <div class="form-field">
            <select
              name={`anglers[${i}].rodreel`}
              placeholder="Rod & reel*"
              on:change={handleChange}
              bind:value={$form.anglers[i].rodreel}
              class:error={$errors.anglers[i].rodreel}
              class="half-width"
              data-input={`anglers-${i}-rodreel`}>
              <option value="" disabled selected>Require rod & reel*</option>
              {#each defaults.yesno as opt}
                <option value={opt}>{opt}</option>
              {/each}
            </select>
          </div>
          <div class="subgrid">
            <div class="form-field">
              <select
                name={`anglers[${i}].waders`}
                placeholder="Waders*"
                on:change={handleChange}
                bind:value={$form.anglers[i].waders}
                class:error={$errors.anglers[i].waders}
                class="full-width"
                data-input={`anglers-${i}-waders`}>
                <option value="" disabled selected>Require waders*</option>
                {#each defaults.yesno as opt}
                  <option value={opt}>{opt}</option>
                {/each}
              </select>
            </div>
            <div class="form-field">
              {#if $form.anglers[i].waders === 'Yes'}
                <select
                  name={`anglers[${i}].wadersize`}
                  placeholder="Size*"
                  on:change={handleChange}
                  bind:value={$form.anglers[i].wadersize}
                  class:error={$errors.anglers[i].wadersize}
                  class="full-width"
                  data-input={`anglers-${i}-wadersize`}>
                  <option value="" disabled selected>Size*</option>
                  {#each defaults.size as opt}
                    <option value={opt}>{opt}</option>
                  {/each}
                </select>
              {/if}
            </div>
          </div>
        </div>
      </div>
    {/each}

    <div class="grid">
      <div>
        <p>Comments</p>
      </div>
      <div>
        <div class="form-field">
          <textarea
            name="comments"
            placeholder="Comments"
            rows="4"
            bind:value={$form.comments}
            class="full-width"
            data-input="comments" />
        </div>
        <div class="form-field">
          <input
            type="checkbox"
            name="terms"
            bind:checked={$form.terms}
            on:click={handleChange}
            data-input="terms" />
          &nbsp;
          <span class:error={$errors.terms}>
            I agree to
            <a
              class="pointer underline"
              on:click={() => dialogHandler('dialogTerms')}>
              Terms and Conditions
            </a>
            *
          </span>
        </div>
        <div class="form-field">
          <input
            type="checkbox"
            name="safety"
            bind:checked={$form.safety}
            on:click={handleChange}
            data-input="safety" />
          &nbsp;
          <span class:error={$errors.safety}>
            I have read the
            <a
              class="pointer underline"
              on:click={() => dialogHandler('dialogSafety')}>
              Health & Safety disclosure
            </a>
            *
          </span>
        </div>
        <div class="form-field">
          <input
            type="checkbox"
            name="waiver"
            bind:checked={$form.waiver}
            on:click={handleChange}
            data-input="waiver" />
          &nbsp;
          <span class:error={$errors.waiver}>
            I will agree to the
            <a
              class="pointer underline"
              on:click={() => dialogHandler('dialogWaiver')}>
              RMTPFG waiver
            </a>
            *
          </span>
        </div>
        <div class="form-field">
          <input
            type="checkbox"
            name="photorelease"
            bind:checked={$form.photorelease}
            on:click={handleChange}
            data-input="photorelease" />
          &nbsp;
          <span class:error={$errors.photorelease}>
            I agree to the
            <a
              class="pointer underline"
              on:click={() => dialogHandler('dialogPhotoRelease')}>
              Photography Release
            </a>
            *
          </span>
        </div>
      </div>
    </div>

    <div class="grid">
      <div />
      <div>
        <button type="submit" data-btn="submit">
          Submit
          {#if $isSubmitting}
            &nbsp;
            <img
              src="./io/preloaders-spin6.gif"
              alt="loading"
              class="loading" />
          {/if}
        </button>
        <!-- {#if (errors)}
      <div class="error" data-msg="error">Error</div>
      {/if} -->
        <!-- <pre>
        <code>{JSON.stringify($form, null, 2)}</code>
      </pre> -->
      </div>
    </div>
  </form>

</div>

<!-- <button on:click={submitSnackbar.open()}>open</button> -->

<Snackbar
  bind:this={submitSnackbar}
  labelText={sb.label}
  class={sb.class}
  timeoutMs="10000"
  data-snackbar="snackbar">
  <Label />
  <!-- <Label>Thank you for your booking enquiry</Label> -->
  <Actions>
    <a class="close-icon pointer" on:click={() => submitSnackbar.close()}>
      <img src="./io/icons8-delete-w.png" alt="close" />
    </a>
  </Actions>
</Snackbar>
